// removed by extract-text-webpack-plugin
module.exports = {"root":"_2fyABQH","left":"_3UdSWbZ","up":"_186ninY","right":"_1qtKDj-"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/ChevronIcon/ChevronIcon.less
 ** module id = 629
 ** module chunks = 0
 **/